<template>
    <yxtf-popover
            placement="bottom"
            width="336"
            trigger="click"
            v-model="visible"
            @show="getUserPointData">
    <div class="yxtbiz-reward">
        <div class="yxtbiz-reward__header">
            <div>
                <img class="yxtbiz-reward__header--avatar"
                     :src="targetUser.imgUrl || defaultAvatar">
                <span class="color-gray-10 font-bolder font-size-16">
                     <yxtbiz-user-name :name="targetUser.fullname" />
                </span>
            </div>
            <yxtf-row class="color-gray-7" type="flex" align="middle">
                <span class="standard-size-14">收到</span>
                <yxt-svg iconClass="point" :remote-url='mediaPath' width="16px" height="16px" style="margin:0 5px"></yxt-svg>
                <span class="standard-size-14">{{targetUser.totalMallPoint}}</span>
            </yxtf-row>
        </div>
        <ul class="yxtbiz-reward__main standard-size-16 font-bolder color-gray-8">
            <li class="yxtbiz-reward--item" :class="{'active border-primary-6': currentIndex === index}" v-for="(point, index) in points" :key="point"
                @click="currentIndex = index">{{point}}
            </li>
            <li class="yxtbiz-reward--item">
                <yxtf-input v-model.number.trim="customPoint"
                            oninput="value=value.replace(/[^\d.]/g,'')"
                            maxlength="4"
                            placeholder="输入数额"
                            @focus="currentIndex=null"></yxtf-input>
            </li>
        </ul>
        <div class="yxtbiz-reward__footer">
            <span class="color-gray-7 standard-size-14">您的可用积分为：{{totalMallPoint}}</span>
            <yxt-button type="primary" @click="save" :disabled="!disabled">打赏</yxt-button>
        </div>
    </div>
        <slot slot="reference"></slot>
    </yxtf-popover>
</template>

<script>
import { getUserPointData, putPointData, getPointSelf } from './service';
import bizSvg from 'yxt-biz-pc/src/mixins/bizSvg';
import {
  FrontPopover,
  FrontRow,
  FrontInput
} from 'yxt-pc';
export default {
  name: 'YxtbizReward',
  mixins: [bizSvg],
  components: {
    YxtfPopover: FrontPopover,
    YxtfRow: FrontRow,
    YxtfInput: FrontInput
  },
  props: {
    targetUserId: {
      type: String,
      required: true
    },
    loginUserId: {
      type: String
    },
    before: Function,
    success: Function,
    error: Function,
    myRemark: { type: String}, // 操作人可用积分变更说明
    mySourceType: { type: Number}, // 操作人可用积分变更来源
    toRemark: { type: String}, // 被打赏人可用积分变更说明
    serviceId: { type: String}, // 业务id,可空。如不为空，积分明细会保存该属性
    myActionType: { type: Number},
    myNameType: { type: Number },
    toActionType: { type: Number},
    toNameType: { type: Number},
    toSourceType: { type: Number}
  },
  data() {
    return {
      visible: false,
      isSendFlower: false,
      points: [5, 10, 50, 100, 200],
      currentIndex: null,
      totalMallPoint: 0,
      customPoint: '',
      targetUser: {
        imgUrl: '',
        username: '',
        totalMallPoint: ''
      },
      defaultAvatar: `${this.$staticBaseUrl}assets/883f6807/1202325e/default_avatar.png`
    };
  },
  computed: {
    disabled() {
      return this.totalMallPoint > 0 && this.point > 0 && this.totalMallPoint >= this.point;
    },
    point() {
      return this.currentIndex !== null ? this.points[this.currentIndex] : this.customPoint;
    }
  },
  methods: {
    getUserPointData() {
      this.getTargetUserPointData();
      this.getPointSelf();
    },
    getPointSelf() {
      getPointSelf().then(res => {
        const { totalMallPoint } = res;
        this.totalMallPoint = totalMallPoint;
      });
    },
    getTargetUserPointData() {
      getUserPointData(this.targetUserId).then(res => {
        this.targetUser = res;
      });
    },
    save() {
      if (this.before && !this.before()) {
        return;
      }

      if (!/^\d{0,4}$/.test(this.point)) {
        this.$message.error('自定义积分只能输入正整数');
        return;
      }
      const params = {
        point: this.point,
        targetUserId: this.targetUserId,
        myRemark: this.myRemark,
        mySourceType: this.mySourceType,
        toRemark: this.toRemark,
        serviceId: this.serviceId,
        myActionType: this.myActionType,
        myNameType: this.myNameType,
        toActionType: this.toActionType,
        toNameType: this.toNameType,
        toSourceType: this.toSourceType
      };
      putPointData(params).then(() => {
        this.getUserPointData();
        this.visible = false;
        this.success && this.success(this.point, this.point + this.targetUser.totalMallPoint, this.totalMallPoint - this.point);
      }).catch(err => {
        this.$message.error(err);
        this.fail && this.fail(err);
      });
    }
  }
};
</script>
